"use client"; // Error components must be Client Components

import { useEffect } from "react";
import fourOhFourImg from "@/assets/img/404-image.jpg";

export default function GlobalError({
  error,
}: Readonly<{
  error: Error & { digest?: string };
}>) {
  useEffect(() => {
    console.error("Global error:", error);
  }, [error]);

  return (
    <html lang="en">
      <head>
        <style>{`
          body.error-body {
            margin: 0;
            display: inline-flex;
            width: 100%;
          }
          main.error-main {
            min-height: 100vh;
            width: 100%;
            background: url(${fourOhFourImg.src}) no-repeat scroll center/cover;
          }
          .error-container {
            padding: 2rem;
            max-width: 100%;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
          }
          .error-title {
            color: #F5F6F7;
            margin-bottom: 2rem;
            font-size: 3.75rem;
            font-weight: 700;
            line-height: 1.1;
          }
          .error-message {
            color: #F5F6F7;
            font-size: 1.5rem;
            font-weight: 400;
            line-height: 1.5;
          }
          .error-links-label {
            font-size: 1.25rem;
            font-weight: 400;
            line-height: 1.5;
            color: #F5F6F7;
            margin-bottom: 8px;
          }
          .error-link {
            font-size: 18px;
            color: #191e24 !important;
            font-weight: 500;
            text-decoration: none;
            margin-bottom: 0.5rem;
            display: inline-flex;
            width: fit-content;
            font-family: sans-serif;
          }
          .error-link:hover {
            text-decoration: underline;
          }
        `}</style>
      </head>
      <body className="error-body">
        <main role="main" className="error-main">
          <div className="error-container">
            <h1 className="error-title">{"System Error"}</h1>
            <p className="error-message">
              {
                "We are currently experiencing issues loading the application resources"
              }
            </p>
            <p className="error-links-label">
              {"Here are some helpful links instead:"}
            </p>

            <a href="https://urbansportsclub.com/en/" className="error-link">
              {"Home"}
            </a>
            <a
              href="https://urbansportsclub.com/en/venues"
              className="error-link"
            >
              {"Sports Offer"}
            </a>
            <a
              href="https://urbansportsclub.com/en/company-sports"
              className="error-link"
            >
              {"Company Sports"}
            </a>
            <a
              href="https://partners.urbansportsclub.com/"
              className="error-link"
            >
              {"Become a Partner"}
            </a>
          </div>
        </main>
      </body>
    </html>
  );
}
